import { Badge } from '@ntconsult/aluma-react';
import { useTranslation } from 'react-i18next';
import type { EstadoEfetivo } from '../types/Campanha';

const TONE = {
  aberta: 'success',
  agendada: 'info',
  encerrada: 'neutral',
  inativa: 'warning',
} as const;

export function EstadoBadge({ estado }: { estado: EstadoEfetivo }) {
  const { t } = useTranslation('campanhas');
  return <Badge tone={TONE[estado]}>{t(`estados.${estado}`)}</Badge>;
}
